//
//
//
//
//
//
//
//
//

import resterrors from '~/components/errors/resterrors.vue';
import error500 from '~/components/errors/error500.vue';

export default {
  name: "nuxt-error",
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    errorPage() {
      if (this.error.statusCode !== 500) {
        return resterrors;
      }
      // catch everything else
      return error500;
    },
}
}
